"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.starredMessageItemMapper = starredMessageItemMapper;
exports.starredMessageMapper = starredMessageMapper;
const models_1 = require("../models");
const UserInfoMapper_1 = require("./UserInfoMapper");
const ChatsMapper_1 = require("./ChatsMapper");
const MessageUtils_1 = require("./MessageUtils");
function starredMessageItemMapper(starredMessageItemResponse, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    return {
        chatId: starredMessageItemResponse.chatId,
        chatType: starredMessageItemResponse.chatType,
        createdAt: starredMessageItemResponse.createdAt,
        message: (0, MessageUtils_1.makeMessage)(starredMessageItemResponse.message, userDirectory, organizationUser, httpAdapter, socketAdapter),
        info: starredMessageItemResponse.chatType === models_1.CHAT_TYPE.PRIVATE &&
            starredMessageItemResponse.info
            ? (0, UserInfoMapper_1.userInfoMapper)(starredMessageItemResponse.info)
            : starredMessageItemResponse.groupInfo
                ? (0, ChatsMapper_1.groupInfoMapper)(starredMessageItemResponse.groupInfo, userDirectory, organizationUser, httpAdapter)
                : starredMessageItemResponse.broadcastInfo &&
                    (0, ChatsMapper_1.broadcastInfoMapper)(starredMessageItemResponse.broadcastInfo, userDirectory, organizationUser, httpAdapter),
    };
}
function starredMessageMapper(starredMessageResponse, existingStarredMessages, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    const starredMessageData = [];
    for (const data of starredMessageResponse.data) {
        starredMessageData.push(starredMessageItemMapper(data, userDirectory, organizationUser, httpAdapter, socketAdapter));
    }
    const existingIds = new Set(existingStarredMessages.data
        .map(d => { var _a, _b, _c; return (_c = (_b = (_a = d.message) === null || _a === void 0 ? void 0 : _a.getMessage) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.id; })
        .filter(Boolean));
    const deduplicatedNewData = starredMessageData.filter(d => {
        var _a, _b, _c;
        const id = (_c = (_b = (_a = d.message) === null || _a === void 0 ? void 0 : _a.getMessage) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.id;
        return !id || !existingIds.has(id);
    });
    return {
        data: [...existingStarredMessages.data, ...deduplicatedNewData],
        limit: starredMessageResponse.limit,
        hasNext: starredMessageResponse.hasNext,
        total: (existingStarredMessages.total || 0) + deduplicatedNewData.length,
    };
}
